import React from "react";

import gettext from "../../shared/utils/gettext";
import DashboardTile from "../DashboardTile";

const TimeLineTile = () => {
  return (
    <DashboardTile experimental>
      <DashboardTile.Title>{gettext("Your timeline")}</DashboardTile.Title>
      <DashboardTile.Body>
        {/*todo use real data*/}
        <a
          href="/cropr/record/record/"
          className="js-log-metric"
          data-metrics_category="dashboard_links"
        >
          5 records
        </a>{" "}
        (demo)
        <br />
        <a href="/supplier/" className="js-log-metric" data-metrics_category="dashboard_links">
          {" "}
          4 new deliveries
        </a>{" "}
        (demo)
        <br />
        <a
          href="/apps/cloudfarm/"
          className="js-log-metric"
          data-metrics_category="dashboard_links"
        >
          7 new datasets
        </a>{" "}
        (demo)
        <br />
        ... (demo)
        <br />
        ... (demo)
        <br />
        ... (demo)
        <br />
        ... (demo)
        <br />
        ... (demo)
        <br />
        ... (demo)
        <br />
      </DashboardTile.Body>
    </DashboardTile>
  );
};
export default TimeLineTile;
